export const ASSET_ISSUE_DUPLICATED_SERIAL_NUMBER_ID = 5;
export const ASSET_ISSUE_DUPLICATED_SELLER_REF_ID = 6;
